import { API } from 'aws-amplify';
import { getVaccinationsByVaccinationYearMonth } from '../graphql/queries';
import {getVaccinationsByChargeTo} from '../graphql/queries';
import { getVaccinationsByPharmacy } from '../graphql/queries';

function xssTest(toCheck) {
  var xssTest = new RegExp('<|>|/|&|#|!', 'g');
  var notOK = xssTest.exec(toCheck);
  if (notOK) {
    return false;
  }
  return true;
}

function xssMessage(fieldName) {
  return 'One of the following special characters (<, >, /, &, #, !) has been entered into ' + fieldName;
}

function displayError(error){
  if(error.errors[0].message.indexOf("401") > -1){
    return "You can't not perform this function at this time. Please contact IT support."
  }
  else {
    return error.errors[0].message + " Please contact IT support."
  }
}

async function getAllVacinations(fromDate, toDate) {
//  console.log('getAllVaccinations ....')
  const startMonth = fromDate.getFullYear() + ((fromDate.getMonth() < 9) ? '0' : '') + (fromDate.getMonth() + 1)
  const endMonth = toDate.getFullYear() + ((toDate.getMonth() < 9) ? '0' : '') + (toDate.getMonth() + 1)
  var limit = 2000;
  var nextToken;
  var filter;
  filter = {
    vaccinationDate: {ge: fromDate, le: toDate}
  }
  var monthsLoop = [];
  var x = 0;
  var VaccinationLoop = [];
  var Vaccinations = [];
  for (var j = startMonth * 1; j <= endMonth; j++){           // determine the months to show
    if (j % 100 > 0 && j % 100 <= 12) {                       // exclude those that arent months over year end
      monthsLoop[x] = j;
      x = x + 1
    }
  }
  x = 0;

    while (x < monthsLoop.length) {
      VaccinationLoop = await API.graphql({
        query: getVaccinationsByVaccinationYearMonth,
        variables: {vaccinationYearMonth: monthsLoop[x], filter: filter, limit: limit}
      })
      Vaccinations = Vaccinations.concat(VaccinationLoop.data.getVaccinationsByVaccinationYearMonth.items);
      nextToken = VaccinationLoop.data.getVaccinationsByVaccinationYearMonth.nextToken;

      while (nextToken){
        VaccinationLoop = await API.graphql({
          query: getVaccinationsByVaccinationYearMonth,
          variables: {vaccinationYearMonth: monthsLoop[x], filter: filter, limit: limit, nextToken: nextToken}
        });
        Vaccinations = Vaccinations.concat(VaccinationLoop.data.getVaccinationsByVaccinationYearMonth.items);
        nextToken = VaccinationLoop.data.getVaccinationsByVaccinationYearMonth.nextToken;        
      }
      x = x + 1
    }
//    console.log('getAllVaccinations end')
    return Vaccinations

}

async function getVaccinationsChargeTo(selectedCustomer, fromDate, toDate) {
  var Vaccinations = [];
  var limit = 2000;
  var nextToken;
  var filter;
  filter = {
    vaccinationDate: {ge: fromDate, le: toDate}
  }
    const Vaccination = await API.graphql({
      query: getVaccinationsByChargeTo,
      variables: {chargeTo: selectedCustomer, limit: limit, filter: filter}
    });
    Vaccinations = Vaccination.data.getVaccinationsByChargeTo.items;
    nextToken = Vaccination.data.getVaccinationsByChargeTo.nextToken;

    while (nextToken){
    const VaccinationLoop = await API.graphql({
      query: getVaccinationsByChargeTo,
      variables: {chargeTo: selectedCustomer, filter: filter, limit: limit, nextToken: nextToken}
    });
    Vaccinations = Vaccinations.concat(VaccinationLoop.data.getVaccinationsByChargeTo.items);
    nextToken = VaccinationLoop.data.getVaccinationsByChargeTo.nextToken;        
    }
    return Vaccinations       
    }

async function getVaccinationsPharmacy(selectedPharmacy, fromDate, toDate) {
  var Vaccinations = [];
  var limit = 2000;
  var nextToken;
  var filter;
  filter = {
    vaccinationDate: {ge: fromDate, le: toDate}
  }
    const Vaccination = await API.graphql({
      query: getVaccinationsByPharmacy,
      variables: {pharmacyCode: selectedPharmacy, filter: filter, limit: limit}
    });
    Vaccinations = Vaccination.data.getVaccinationsByPharmacy.items;
    nextToken = Vaccination.data.getVaccinationsByPharmacy.nextToken;

    while (nextToken){
      const VaccinationLoop = await API.graphql({
        query: getVaccinationsByPharmacy,
        variables: {pharmacyCode: selectedPharmacy, filter: filter, limit: limit, nextToken: nextToken}
      });
      Vaccinations = Vaccinations.concat(VaccinationLoop.data.getVaccinationsByPharmacy.items);
      nextToken = VaccinationLoop.data.getVaccinationsByPharmacy.nextToken;        
      }
    return Vaccinations
  }

  function DupVaccinationCheck(Vaccinations) {
    var VaccinationsDup = Vaccinations;
    for ( var i=0; i< Vaccinations.length; i++) {
      for (var j=0; j < VaccinationsDup.length; j++){
        if (Vaccinations[i].contract.voucherCode == VaccinationsDup[j].contract.voucherCode){                               // check the same contract
          if (i !== j && Vaccinations[i].patientName.toLowerCase() == VaccinationsDup[j].patientName.toLowerCase()) {       // check if names are the same
            Vaccinations[i].duplicate = true}
          if (i !== j && Vaccinations[i].customerAttributes.length > 1 && VaccinationsDup[j].customerAttributes.length > 1){
            if (Vaccinations[i].customerAttributes[1].value.toLowerCase() === VaccinationsDup[j].customerAttributes[1].value.toLowerCase()){            // check if attribute 2 is the same
              Vaccinations[i].duplicate = true;
            }
          }
        }
      }
    }
    return Vaccinations;
  }

export default{
  xssTest,
  xssMessage,
  displayError,
  getAllVacinations,
  getVaccinationsChargeTo,
  getVaccinationsPharmacy,
  DupVaccinationCheck
}
